// ============================================================================
// OBT F3-E — Bildirim olay etiketleri + derin-bağlantı hedef eşlemesi
// ============================================================================
// KAYNAK: backend enums.py NotificationEvent. Yeni değer türetilmez.

export const NOTIFICATION_EVENT_LABELS = Object.freeze({
  campaign_published: 'Bilgi talebi yayınlandı',
  response_due_soon: 'Son tarih yaklaşıyor',
  response_due_passed: 'Son tarih geçti',
  bm_review_pending: 'İnceleme bekliyor',
  revision_requested: 'Revizyon istendi',
  my_review_pending: 'MY incelemesi bekliyor',
  director_decision_pending: 'Müdür kararı bekliyor',
  suggested_park_approved: 'Önerilen park onaylandı',
  suggested_park_rejected: 'Önerilen park reddedildi',
  decision_set_finalized: 'Nihai karar kesinleşti',
  application_result_recorded: 'Uygulama sonucu kaydedildi',
  warranty_expiring: 'Garanti bitişi yaklaşıyor',
});

export function notificationLabel(event) {
  if (!event) return 'Bildirim';
  return NOTIFICATION_EVENT_LABELS[event] || String(event);
}

// Rol paneli görünümleri: overview | campaigns | review | decisions | memory | foreman
// Her rolün gerçekten sahip olduğu görünüm farklıdır; hedef yoksa null → yalnız
// okundu işaretlenir, gezinme yapılmaz (yetkisiz ekran AÇILMAZ).
const EVENT_TARGET = Object.freeze({
  campaign_published: { foreman: 'foreman', engineer: 'campaigns', deputy: 'campaigns', director: 'campaigns' },
  response_due_soon: { foreman: 'foreman' },
  response_due_passed: { foreman: 'foreman' },
  bm_review_pending: { engineer: 'review' },
  revision_requested: { foreman: 'foreman' },
  my_review_pending: { deputy: 'review' },
  director_decision_pending: { director: 'decisions' },
  suggested_park_approved: { foreman: 'foreman' },
  suggested_park_rejected: { foreman: 'foreman' },
  decision_set_finalized: { director: 'decisions', deputy: 'review', engineer: 'review' },
  application_result_recorded: { director: 'memory', engineer: 'memory' },
  warranty_expiring: { director: 'memory', engineer: 'memory' },
});

/**
 * Bir bildirimin, verilen rol için gideceği panel görünümü (yoksa null).
 * @param {string} event
 * @param {'director'|'deputy'|'engineer'|'foreman'} role
 */
export function notificationTargetView(event, role) {
  const map = EVENT_TARGET[event];
  if (!map) return null;
  return map[role] || null;
}
